import React from "react";
import UsageGuideCard from "../usage-guide-card/UsageGuideCard";
import UsageGuideStepProps from "./usage-guide-step-props.interface";
import { ReactComponent as YellowArrowRightIcon } from "../../../../../assets/icons/yellow-arrow-right-icon.svg";

const InteractionTestStart = ({
  handleNextStep,
  handleClose,
}: UsageGuideStepProps) => {
  return (
    <div className="step__interaction-test-start">
      <UsageGuideCard handleClose={handleClose}>
        <div className="d-flex">
          <div className="mb-5">
            <h1>Let&apos;s get to the how:</h1>
            <p>Do you want to play the animation that will show you the stat? Just click on the respective button.</p>
          </div>
          <div className="align-self-end">
            <button
              type="button"
              onClick={handleNextStep}
              className="clickable"
            >
              Next
              <YellowArrowRightIcon/>
            </button>
          </div>
        </div>
      </UsageGuideCard>
    </div>
  );
};

export default InteractionTestStart;
